<template>
  <div class="UserOrdersFilters">
    <b-message v-if="error" type="is-danger" size="is-small">
      {{ error }}
    </b-message>

    <div class="UserOrdersFilters__fields">
      <b-field label="Data od" :type="error ? 'is-danger' : null">
        <b-input
            type="date"
            :value="value.dateFrom"
            :disabled="isLoading"
            @input="update('dateFrom', $event)"
        />
      </b-field>

      <b-field label="Data do" :type="error ? 'is-danger' : null">
        <b-input
            type="date"
            :value="value.dateTo"
            :disabled="isLoading"
            @input="update('dateTo', $event)"
        />
      </b-field>

      <b-field label="Status">
        <b-select
            placeholder="Wszystkie"
            :value="value.status"
            :disabled="isLoading"
            expanded
            @input="update('status', $event)"
        >
          <option value="">Wszystkie</option>
          <option v-for="status in statusOptions" :key="status.value" :value="status.value">
            {{ status.label }}
          </option>
        </b-select>
      </b-field>
    </div>

    <div class="UserOrdersFilters__actions">
      <button
          type="button"
          class="button is-small is-primary"
          :class="{ 'is-loading': isLoading }"
          :disabled="isLoading"
          @click="$emit('submit')"
      >
        Filtruj
      </button>
      <button
          type="button"
          class="button is-small is-light"
          :disabled="isLoading"
          @click="$emit('clear')"
      >
        Wyczyść
      </button>
    </div>
  </div>
</template>

<script>
import config from '@/config'

export default {
  name: 'UserOrdersFilters',
  props: {
    value: {
      type: Object,
      required: true
    },
    error: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    statusOptions() {
      return Object.keys(config.company.orderStatusNames)
          .filter((status) => status !== 'all')
          .map((status) => ({
            value: status,
            label: config.company.orderStatusNames[status]
          }))
    }
  },
  methods: {
    update(field, value) {
      this.$emit('input', {
        ...this.value,
        [field]: value || ''
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.UserOrdersFilters {
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid #edf0f4;

  &__fields {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: 0.5rem;
    justify-content: space-between;

    .field {
      flex: 1 1 calc(33.333% - 0.5rem);
      min-width: 160px;
    }
  }

  &__actions {
    display: flex;
    gap: 8px;
    margin-top: 8px;
  }
}
</style>